import { render, staticRenderFns } from "./ConfigFontSize.vue?vue&type=template&id=406a39c3&scoped=true"
import script from "./ConfigFontSize.vue?vue&type=script&lang=js"
export * from "./ConfigFontSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a39c3",
  null
  
)

export default component.exports